import { AccountStatus } from 'pages/CommandCenter/Accounts/types';

/**
 * BillingBanner visibility helpers.
 *
 * Context:
 * - Some accounts can be temporarily granted access (currently a 3-hour window) via "Request access for 3 Hours".
 * - During that window the backend may flip billing/account state fields in ways that previously caused the
 *   "Activate" CTA to disappear even though the customer should still be able to fully activate immediately.
 *
 * Design:
 * - UI should keep the "Activate" CTA visible during temporary access so customers can complete full activation.
 * - Backend remains the source of truth and enforces whether activation is allowed; UI should not attempt to
 *   re-implement authorization rules.
 */

export function shouldShowActivateAccountCta(params: { companyStatus?: AccountStatus; isTrialActive?: boolean }): boolean {
    const { companyStatus, isTrialActive } = params;
    return companyStatus === AccountStatus.new || Boolean(isTrialActive);
}
